import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input } from 'angular-ts-decorators';
import { generateVideoUrl } from '../utils/generate-video-url';
import template from './support-video-thumbnail.component.html';
var SupportVideoThumbnailComponent = (function () {
    function SupportVideoThumbnailComponent($q, videoService) {
        this.$q = $q;
        this.videoService = videoService;
    }
    SupportVideoThumbnailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.videoService
            .thumbnailProvider()
            .then(function (provider) {
            var _a;
            if (!_this.video || !_this.video.videoId) {
                return;
            }
            if (!_this.group) {
                return;
            }
            _this.$q.when(provider.generate(_this.video.videoId))
                .then(function (thumbnail) { _this.videoThumbnailSrc = thumbnail; });
            _this.videoUrl = generateVideoUrl(_this.group, (_a = _this.video) === null || _a === void 0 ? void 0 : _a.id);
        });
    };
    SupportVideoThumbnailComponent.$inject = ['$q', 'videoService'];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SupportVideoThumbnailComponent.prototype, "group", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SupportVideoThumbnailComponent.prototype, "video", void 0);
    SupportVideoThumbnailComponent = __decorate([
        Component({
            selector: 'supportVideoThumbnail',
            template: template,
        }),
        __param(0, Inject('$q')),
        __param(1, Inject('videoService')),
        __metadata("design:paramtypes", [Function, Object])
    ], SupportVideoThumbnailComponent);
    return SupportVideoThumbnailComponent;
}());
export { SupportVideoThumbnailComponent };
